<template lang="pug">
study-result-last-minute-check-list.study-result-last-minute-check(
  modalTitle='大問',
  :userRole='userRole',
  :currentLink='currentLink',
  :sideMenuLinkEvent='sideMenuLinkEvent',
  :logoutEvent='logoutEvent',
  :breadcrumbs='breadcrumbs',
  :breadcrumbMoveEvent='breadcrumbMoveEvent',
  :images='images',
  :imageListClickEvent='imageListClickEvent',
  :titleText='titleText',
  :studyResultLastMinuteChecks='studyResultLastMinuteChecks',
  :modalImageUrl='modalImageUrl'
)
  template(#sideMenuSeparateText) 設定
  template(#logoutText) サインアウト
  template(#imageListLabel) スクリーンショット
  template(#problemNumberHeader) 大問番号
  template(#questionNumberHeader) 小問番号
  template(#correctAnswerHeader) 正解情報
  template(#correctSymbolHeader) 今回の結果
  template(#previousCorrectSymbolHeader) 前回の結果
  template(#previousTwoCorrectSymbolHeader) 前々回の結果
  template(#AnnotationText) …テスト前にもう一度確認しましょう
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import StudentsApi from '@/mixins/api/StudentsApi'
import StudyResultDetailsApi from '@/mixins/api/StudyResultDetailsApi'
import StudyResultLastMinuteCheckList from '@/components/templates/manager/history/StudyResultLastMinuteCheckList.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultDetailImage, StudyResultLastMinuteCheckType } from '@/models/studyResultDetailModel'
import { LinkSetting, SideMenuSettings } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { StudyResultUtils } from '@/utils/StudyResultUtils'
import { StudentManagementUtils } from '@/utils/StudentManagementUtils'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * 履歴管理・直前チェック画面（講師・先生）
 */
@Component({
  components: {
    StudyResultLastMinuteCheckList,
  },
})
export default class StudyResultLastMinuteCheck extends Mixins(LoginMethods, StudentsApi, StudyResultDetailsApi) {
  // テスト詳細ID
  private get studyId(): number {
    return Number(this.$route.params.studyId)
  }

  // 生徒ID
  private get studentId(): number {
    return Number(this.$route.params.studentId)
  }

  // 小項目ID
  private get sUnitId(): number {
    return Number(this.$route.params.sUnitId)
  }

  // パンくず
  private breadcrumbs: breadcrumbType[] = [
    {
      label: '履歴管理',
      location: { name: 'BranchHistoryStudyResultManagement' },
    },
    {
      label: '生徒を選ぶ',
      location: { name: 'BranchHistoryStudyResultStudentSelect', params: { studyId: String(this.studyId) } },
    },
    {
      label: 'さんの成績',
      location: {
        name: 'BranchHistoryStudyResultSummary',
        params: { studyId: String(this.studyId), studentId: String(this.studentId) },
      },
    },
    {
      label: '直前チェックCBT',
    },
  ]

  // 教室長・講師権限
  private userRole: UserRoles = UserRoles.BRANCH

  // サイドメニューの現在リンク
  private currentLink: LinkSetting = SideMenuSettings.MANAGER_HISTORY

  // 画像情報
  private images: StudyResultDetailImage[] = []

  // モーダルに表示する画像URL
  private modalImageUrl = ''

  // タブに表示するタイトル
  private titleText = ''

  // テスト結果直前チェック詳細表示情報
  private studyResultLastMinuteChecks: StudyResultLastMinuteCheckType[] = []

  // 初期表示処理
  private async mounted() {
    // 表示情報を取得
    // API呼び出し
    this.$loading.start()

    this.images = await this.getStudyResultImageUrl(
      this.studentId,
      this.sUnitId,
      this.userRole,
      SUnitCategorySetting.LAST_MINUTE_CHECK
    )
    // 結果詳細情報を取得
    const apiResponse = await this.getStudyResultLastMinuteCheck(this.studentId, this.sUnitId, this.userRole)
    this.titleText = StudyResultUtils.getStudyResultLastMinuteCheckTitle(apiResponse)
    this.studyResultLastMinuteChecks = StudyResultUtils.buildStudyResultLastMinuteChecks(apiResponse)
    // 生徒名を取得
    const apiResponseStudent = await this.getStudentData(this.studentId, this.userRole)
    this.breadcrumbs[2].label =
      StudentManagementUtils.getStudentUserName(apiResponseStudent) + this.breadcrumbs[2].label
    this.$loading.complete()
  }

  // サイドメニュー遷移イベント
  private sideMenuLinkEvent(link: LinkSetting) {
    // 設定されたリンク先ページへ遷移
    this.$router.push({ name: `Branch${link.name}` })
  }

  // ログアウトイベント
  private logoutEvent() {
    this.logout()
    // ログインページへ遷移
    this.$router.push({ name: 'BranchLogin' })
  }

  // パンくず遷移イベント
  private breadcrumbMoveEvent(breadcrumb: breadcrumbType) {
    if (breadcrumb.location) {
      this.$router.push(breadcrumb.location)
    }
  }

  // 画像一覧クリック時イベント
  private imageListClickEvent(image: StudyResultDetailImage) {
    this.modalImageUrl = image.imageUrl
  }
}
</script>
